import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menus: [
      {
        name: "Ev",
        icon: "icofont-ui-home",
        to: "/",
        roles: ["SuperAdmin", "GeneralAdmin", "HrAdmin"],
      },
      {
        name: "Statistic",
        icon: "icofont-chart-bar-graph",
        to: "/Report",
        roles: ["SuperAdmin", "GeneralAdmin", "HrAdmin"],
      },
      {
        name: "Characters",
        icon: "icofont-businessman",
        to: "/characters",
        roles: ["SuperAdmin"],
      },
      {
        name: "ChoiceValues",
        icon: "icofont-pie-chart",
        to: "/choiceValues",
        roles: ["SuperAdmin"],
      },
      {
        name: "Values",
        icon: "icofont-handshake-deal",
        to: "/values",
        roles: ["SuperAdmin"],
      },
      {
        name: "Scenarios",
        icon: "icofont-ui-movie",
        to: "/scenarios",
        roles: ["SuperAdmin"],
      },
      {
        name: "Scenes",
        icon: "icofont-paper",
        to: "/scenes",
        roles: ["SuperAdmin"],
      },
      {
        name: "Companies",
        icon: "icofont-ui-home",
        to: "/companies",
        roles: ["SuperAdmin"],
      },
      {
        name: "Users",
        icon: "icofont-ui-user",
        to: "/users",
        roles: ["SuperAdmin"],
      },
    ],
  },

  getters: {
    getMenus(state) {
      return state.menus;
    },
  },
});
